import React, { Fragment, useEffect } from 'react'

import BoxRequestCode from './BoxRequestCode'
import BoxNewPassword from './BoxNewPassword'
import BoxConfirmationForgotPass from './BoxConfirmationForgotPass'
import BoxConfirmationResendEmail from './BoxConfirmationResendEmail'
import BoxConfirmationResendPass from './BoxConfirmationResendPass'
import { Helmet } from 'react-helmet'
import OnDemandLiveRegion from 'on-demand-live-region'
const ForgotPasswordForm = (props) => {
  useEffect(() => {
    const liveRegionDelayed = new OnDemandLiveRegion({
      delay: 500
    })
    const timer = setTimeout(() => {
      props.isConfirmationForgotPass
        ? liveRegionDelayed.say(`Você está em "${`${process.env.RAZZLE_TITLE} - Sua senha foi alterada com sucesso.`}"`)
        : props.isCodeSet
        ? liveRegionDelayed.say(`Você está em "${`${process.env.RAZZLE_TITLE} - Código de Confirmação.`}"`)
        : liveRegionDelayed.say(`Você está em "${`${process.env.RAZZLE_TITLE} - Esqueceu a senha?.`}"`)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Fragment>
      {props.isConfirmationForgotPass ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Sua senha foi alterada com sucesso.`}</title>
          </Helmet>
          <BoxConfirmationForgotPass {...props} />
        </>
      ) : props.isConfirmationResendEmail ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Confirmação reenviada`}</title>
          </Helmet>
          <BoxConfirmationResendEmail {...props} />
        </>
      ) : props.isConfirmationResendPass ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Senha enviada.`}</title>
          </Helmet>
          <BoxConfirmationResendPass {...props} />
        </>
      ) : props.isCodeSet ? (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Código de Confirmação`}</title>
          </Helmet>
          <BoxNewPassword {...props} />
        </>
      ) : (
        <>
          <Helmet>
            <title>{`${process.env.RAZZLE_TITLE} - Esqueceu a senha?`}</title>
          </Helmet>
          <BoxRequestCode {...props} />
        </>
      )}
    </Fragment>
  )
}

export default ForgotPasswordForm
